import { startTransition } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtom, useSetAtom } from 'jotai';
import T from '@wojtekmaj/react-t';

import ButtonLink from '@rewardopl/react-ui/button_link';

import { post } from '@rewardopl/utils/network';

import {
  maybeCurrentAccountRoleState,
  maybeCurrentAccountState,
  maybeCurrentBusinessState,
} from '../store';

export default function LogoutButton() {
  const navigate = useNavigate();
  const [currentAccount, setMaybeCurrentAccount] = useAtom(maybeCurrentAccountState);
  const setMaybeCurrentAccountRole = useSetAtom(maybeCurrentAccountRoleState);
  const setMaybeCurrentBusiness = useSetAtom(maybeCurrentBusinessState);

  async function logout() {
    await post('/api/accounts/logout');

    startTransition(() => {
      setMaybeCurrentAccount(null);
      setMaybeCurrentAccountRole(null);

      setTimeout(() => {
        navigate('/login');
        setTimeout(() => setMaybeCurrentBusiness(null), 100);
      }, 0);
    });
  }

  if (!currentAccount) {
    return null;
  }

  return (
    <ButtonLink onClick={logout}>
      <T>Log out</T>
    </ButtonLink>
  );
}
